import {Routes, RouterModule} from '@angular/router';

import {SupportComponent} from './support.component';
import {VideosComponent} from './video/videos.component';
import {VideosModalComponent} from './video/modals/videos-modal.component';
import {PDFsComponent} from './pdf/pdfs.component';
import {PdfModalComponent} from './pdf/modals/pdf-modal.component';
import {InformationsComponent} from './informations/informations.component';
import {ReleaseNoteComponent} from "./release-note/release-note.component";
import {ReleaseNoteModalComponent} from "./release-note/modals/release-note-modal.component";

export const SupportRoutesModule = RouterModule.forChild([
        {
            path: '',
            component: SupportComponent,
            redirectTo: 'overview',
            pathMatch: 'full',
            data: {
                // breadcrumb: 'Support-Center',
                // breadcrumbSpecific: 'Support-Center',
            }
        },
        {
            path: 'overview',
            component: SupportComponent,
            data: {
                breadcrumb: '',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'videos',
            component: VideosComponent,
            data: {
                breadcrumb: 'Support Center Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'videos/create/:lang', component: VideosModalComponent
        },
        {
            path: 'videos/edit/:id/:lang', component: VideosModalComponent
        },
        {
            path: 'pdfs', component: PDFsComponent,
            data: {
                breadcrumb: 'Support Center Management',
                breadcrumbSpecific: ''
            }
        },
        {
            path: 'pdfs/create/:lang', component: PdfModalComponent
        },
        {
            path: 'pdfs/edit/:id/:lang', component: PdfModalComponent
        },
        {
            path: 'release-note', component: ReleaseNoteComponent,
            data: {
                breadcrumb: 'Release Notes',
                breadcrumbSpecific: ''
            }
        },
        {
            path: 'release-note/create/:lang', component: ReleaseNoteModalComponent
        },
        {
            path: 'release-note/edit/:id/:lang', component: ReleaseNoteModalComponent
        },
        {
            path: 'basic', component: InformationsComponent,
            data: {
                breadcrumb: 'Support Center Management',
                breadcrumbSpecific: ''
            }
        },
        {
            path: ':id', component: SupportComponent,
            data: {
                breadcrumb: '',
            },
        }
    ]
);
